<template>
  <v-card class="rounded-lg bulk-unmapping-card">
    <v-card-title class="d-flex justify-space-between align-start pa-6 pb-2 flex-shrink-0">
      <div>
        <div class="text-h6 font-weight-bold">{{ title }}</div>
        <div class="text-body-2 grey--text text--darken-1 mt-1">
          Tinjau kembali data sebelum melanjutkan
        </div>
      </div>
      <v-btn icon @click="onCancel" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider />

    <v-card-text class="pa-6">
      <v-alert
        outlined
        color="red"
        class="rounded-lg mb-6 warning-alert"
        icon="mdi-alert-outline"
      >
        <div class="font-weight-bold red--text mb-1">Perhatian</div>
        <div class="text-body-2">
          Merchant yang di-unmapping akan <strong>kehilangan akses QrisTap</strong>
          dan tidak dapat bertransaksi menggunakan metode tersebut hingga
          di-mapping kembali.
        </div>
      </v-alert>

      <div class="text-overline grey--text text--darken-1 mb-2">RINGKASAN UNMAPPING</div>

      <v-card outlined class="rounded-lg mb-4">
        <div class="d-flex justify-space-between align-center pa-3 px-4" style="background-color: #f7f8fa">
          <span>Total merchant dipilih</span>
          <span class="font-weight-bold">{{ merchants.length }} merchant</span>
        </div>
        <v-divider />
        <div class="d-flex justify-space-between align-center pa-3 px-4">
          <span>Sudah ter-mapping (akan di-unmapping)</span>
          <span class="red--text font-weight-bold">{{ mappedCount }} merchant</span>
        </div>
        <v-divider />
        <div class="d-flex justify-space-between align-center pa-3 px-4">
          <span>Belum ter-mapping (tidak berpengaruh)</span>
          <span class="grey--text text--darken-1 font-weight-bold">{{ unmappedCount }} merchant</span>
        </div>
      </v-card>

      <div class="text-overline grey--text text--darken-1 mb-2">DAFTAR MERCHANT YANG AKAN DI-UNMAPPING</div>

      <v-card outlined class="rounded-lg">
        <button
          type="button"
          class="d-flex justify-space-between align-center pa-3 px-4 expand-toggle"
          :aria-expanded="expanded"
          @click="expanded = !expanded"
        >
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account-multiple</v-icon>
            <span class="font-weight-medium">{{ merchants.length }} merchant dipilih</span>
          </div>
          <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </button>

        <v-expand-transition>
          <div v-show="expanded">
            <v-divider />
            <div class="merchant-list-wrapper">
              <v-simple-table dense fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Merchant ID</th>
                      <th class="text-left">Nama Merchant</th>
                      <th class="text-left">Channel Provider</th>
                      <th class="text-left">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in merchants" :key="row.id">
                      <td class="primary--text">{{ row.mid || '—' }}</td>
                      <td>{{ row.merchant_name || '—' }}</td>
                      <td>{{ row.channel_provider_name || '—' }}</td>
                      <td>
                        <v-chip
                          v-if="isMapped(row)"
                          small
                          color="red"
                          text-color="white"
                        >
                          {{ statusLabel(row) }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          color="grey lighten-2"
                          text-color="grey darken-2"
                        >
                          {{ statusLabel(row) }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </v-expand-transition>
      </v-card>
    </v-card-text>

    <v-divider />

    <v-card-actions class="pa-6 flex-shrink-0">
      <v-btn outlined color="primary" class="rounded-lg px-6" @click="onCancel" :disabled="loading">
        Batal
      </v-btn>
      <v-spacer />
      <v-btn
        color="red"
        class="rounded-lg elevation-0 px-6 white--text"
        :loading="loading"
        :disabled="loading || merchants.length < 1"
        @click="onConfirm"
      >
        Ya, Lakukan Unmapping
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'BulkUnmappingConfirm',
  props: {
    merchants: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      expanded: this.merchants.length <= 5,
    };
  },
  watch: {
    merchants: {
      handler(newList) {
        this.expanded = (newList || []).length <= 5;
      },
      immediate: false,
    },
  },
  computed: {
    title() {
      return this.merchants.length > 1
        ? 'Konfirmasi Bulk Unmapping'
        : 'Konfirmasi Unmapping';
    },
    mappedCount() {
      return this.merchants.filter((row) => this.isMapped(row)).length;
    },
    unmappedCount() {
      return this.merchants.length - this.mappedCount;
    },
  },
  methods: {
    isMapped(row) {
      return Number(row.channel_provider_mapping_status) === 1;
    },
    statusLabel(row) {
      return row.channel_provider_mapping_alias
        || (this.isMapped(row) ? 'Sudah Dimapping' : 'Belum Dimapping');
    },
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.bulk-unmapping-card {
  display: flex;
  flex-direction: column;
}

.warning-alert {
  background-color: #fff5f5 !important;
}

.expand-toggle {
  background-color: #e6f3f4;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
}
.expand-toggle:focus {
  outline: 2px solid #378595;
  outline-offset: -2px;
}

.merchant-list-wrapper {
  max-height: 320px;
  overflow-y: auto;
}
</style>
